package com.wintermar.inspection.feature.presentation.inspection.answer.widget

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.component.button.InputButton
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import com.wintermar.inspection.feature.util.finding_category.FindingCategoryView
import com.wintermar.inspection.graphql.type.FindingCategory
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.category
import inspection.composeapp.generated.resources.ic_arrow_right
import org.jetbrains.compose.resources.stringResource

@Composable
fun ContentItemFindingCategory(
    show: Boolean,
    findingCategory: FindingCategory,
    disableClick: Boolean,
    color: ThemeColor = LocalAppTheme.current.color,
    dimension: AppDimension = LocalAppTheme.current.dimension,
    onClick: () -> Unit
) {
    AnimatedVisibility(
        visible = show,
        enter = fadeIn(),
        exit = fadeOut()
    ) {
        Column(
            modifier = Modifier.fillMaxWidth()
                .background(
                    color = color.surface.neutral.subtlest.default,
                    shape = RoundedCornerShape(dimension.radius.md)
                )
                .padding(dimension.spacing.space3),
            verticalArrangement = Arrangement.spacedBy(dimension.spacing.space1)
        ) {
            TextBodySmall(
                text = stringResource(Res.string.category),
                bold = true
            )

            InputButton(
                disabledClick = disableClick,
                trailingIcon = if (disableClick) null else Res.drawable.ic_arrow_right,
                onClick = onClick,
                modifier = Modifier.fillMaxWidth()
            ) {
                FindingCategoryView(
                    category = findingCategory,
                    showDescription = false,
                    bold = false
                )
            }
        }
    }
}
